<template>
  <v-card
    class="bg-light text-center h-100"
    elevation="0"
  >
    <v-card-title class="border-bottom border-white text-center d-block font-weight-bold">
      Média geral
    </v-card-title>
    <v-card-text class="d-flex flex-column justify-content-center align-items-center h-100">
      <ellipse-progress
        :progress="avg_cycle_performance"
        :color="nitro_color"
      >
        <div class="price">
          <h4 class="font-weight-bolder">
            {{ avg_cycle_performance | roundedDecimalPlace }}%
          </h4>
        </div>
      </ellipse-progress>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import {roundedDecimalPlace} from "@/filters/roundDecimalPlace";
import {nitro_color} from "@/constants/colors"
export default {
  filters: {
    roundedDecimalPlace,
  },
  data(){
    return {
      nitro_color
    }
  },
  computed:{
    ...mapGetters(['avg_cycle_performance']),
  }
}
</script>
